export default __webpack_public_path__ + "static/media/Funghi.5991fecb.jpg";